import React, { useMemo } from "react";
import AppBootstrap from "../components/App/AppBootstrap";
import { Store } from "../components/Cache";
import Firebase, { FirebaseContext } from "../components/Firebase";
import withAuthentication from "../components/Session/withAuthentication";
import "../styles/globals.css";
import "react-datepicker/dist/react-datepicker.css";

const AppContent = ({ Component, pageProps }) => {
  return (
    <AppBootstrap>
      <Component {...pageProps} />
    </AppBootstrap>
  );
};

const AppContentWithAuth = withAuthentication(AppContent);

const App = ({ Component, pageProps }) => {
  const firebase = useMemo(() => new Firebase(), []);

  return (
    <Store>
      <FirebaseContext.Provider value={firebase}>
        <AppContentWithAuth Component={Component} pageProps={pageProps} />
      </FirebaseContext.Provider>
    </Store>
  );
};

export default App;
